
webpack.register(
    'blocks/qualifying-sectional-event-header/qualifying-sectional-event-header',
    function() {
        return import('blocks/qualifying-sectional-event-header/qualifying-sectional-event-header');
    },
    true
);